var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E0F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.887V19.2218M11 19.2218H16.3347M11 19.2218L15.1255 15.3452C16.0811 14.3891 17.2633 13.6907 18.5618 13.3151C19.8603 12.9395 21.2328 12.899 22.5512 13.1973C23.8696 13.4956 25.091 14.123 26.1013 15.021C27.1117 15.919 27.8781 17.0583 28.329 18.3326M30.5607 28.113V22.7782M30.5607 22.7782H25.226M30.5607 22.7782L26.4352 26.6548C25.4796 27.6109 24.2974 28.3093 22.9989 28.6849C21.7004 29.0605 20.3279 29.101 19.0095 28.8027C17.6911 28.5044 16.4697 27.877 15.4594 26.979C14.449 26.081 13.6826 24.9417 13.2317 23.6674",
    stroke: "#00A3FA",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedIcon);
export default __webpack_public_path__ + "static/media/updated-icon.12d9ad543a3baf648b2b5043bd5f7a56.svg";
export { ForwardRef as ReactComponent };